import React, {useState, useEffect} from "react";
import { cfLogo } from "../../assets";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { setCookie } from "../../helper";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLogInUser, selectIsUserFromShopify } from "../../common/authenticateDashboard/authSlice";

const Signup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isReferrerShopify = useSelector(selectIsUserFromShopify);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    email: null,
    password: null,
    confirmPassword:null,
    server: null,
  });


  useEffect(() => { 
    window.location.href = "https://www.causalfunnel.com/fix-my-conversion-funnel/";
  }, [])

  const handleSignup = async() => {
    try {
      setLoading(true);
      setError({ ...error, server: null });
      // validate email and password
      if (!email && !password && !confirmPassword) {
        return setError({
          ...error,
          email: "Email is required",
          password: "Password is required",
          confirmPassword: "Confirm Password is required",
        });
      }
      if (!email || !password || !confirmPassword) {
          email ?
              (password ?
                    setError({ ...error, confirmPassword: "confirm Password is required" })
                    :
                    setError({ ...error, password: "Password is required" })
              )
              : setError({ ...error, email: "Email is required" });
        return;
      }
        
     if (password && confirmPassword) {
            if (password !== confirmPassword) {
                setError({ ...error, server: "Password & Confirm Password must be same" });
          }
      }

      // login user data
      const userInfo = await createUserWithEmailAndPassword(auth, email, password)
      const user = userInfo?.user?.email;

      // check if referer is shopify
      if (isReferrerShopify) {
        dispatch(setLogInUser(user));
      } else {
        setCookie("user", userInfo?.user?.email, 3);
      }
      return navigate('/');
    } catch (err) {
      console.log(err);
      setError({ ...error, server: err.message.split('Firebase: ')[1] });
    } finally {
      // stop loading
      setLoading(false);
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error)
      setError({
        ...error,
        email: null,
      });
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error)
      setError({
        ...error,
        password: null,
      });
  }
    
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (error)
      setError({
        ...error,
        confirmPassword: null,
      });
  }

  return (
    <section className="login__page min-h-screen bg-neutral-200 dark:bg-neutral-700 flex items-center justify-center">
      <div className="container p-4 sm:p-10 mx-auto text-neutral-800 dark:text-neutral-200 flex items-center justify-center">
        <div className="block rounded-lg bg-neutral-200 shadow-lg dark:bg-neutral-800">
          <div className="md:px-12">
            <div className="mx-6 py-12">
              {/* <!--Logo--> */}
              <div className="text-center">
                <img
                  className="mx-auto w-48 sm:w-64 md:w-80 mb-3"
                  src={cfLogo}
                  alt="logo"
                />
              </div>

              <form>
                <p className="mb-4 text-center">Join Now & Start your free 14-day trial</p>
                {/* <!--Email input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input
                    onChange={handleEmailChange}
                    type="email"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0 border dark:!border-neutral-200 !border-neutral-800 rounded "
                    id="exampleFormControlInput1"
                    placeholder="Email"
                  />
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-neutral-200 peer-focus:dark:bg-neutral-800 ${
                      email === ""
                        ? ""
                        : "-translate-y-[0.9rem] scale-[0.8] bg-color"
                    }`}
                  >
                    Email*
                  </label>
                  {/* error message */}
                  <div className="text-left max-w-xs">
                    <p className="text-xs text-red-500">
                      {error.email && error.email}
                    </p>
                  </div>
                </div>

                {/* <!--Password input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input
                    onChange={handlePasswordChange}
                    type="password"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0 border dark:!border-neutral-200 !border-neutral-800 rounded"
                    id="exampleFormControlInput11"
                    placeholder="Password"
                  />
                  <label
                    htmlFor="exampleFormControlInput11"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-neutral-200 peer-focus:dark:bg-neutral-800 ${
                      password === ""
                        ? ""
                        : "-translate-y-[0.9rem] scale-[0.8] bg-color"
                    }`}
                  >
                    Password*
                  </label>
                  {/* error message */}
                  <div className="text-left max-w-xs">
                    <p className="text-xs text-red-500">
                      {error.password && error.password}
                    </p>
                  </div>
                </div>
                              
                {/* <!--Confirm Password input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input
                    onChange={handleConfirmPasswordChange}
                    type="password"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0 border dark:!border-neutral-200 !border-neutral-800 rounded"
                    id="exampleFormControlInput12"
                    placeholder="Confirm Password"
                  />
                  <label
                    htmlFor="exampleFormControlInput12"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-neutral-200 peer-focus:dark:bg-neutral-800 ${
                      confirmPassword === ""
                        ? ""
                        : "-translate-y-[0.9rem] scale-[0.8] bg-color"
                    }`}
                  >
                    Confirm Password*
                  </label>
                  {/* error message */}
                  <div className="text-left max-w-xs">
                    <p className="text-xs text-red-500">
                      {error.confirmPassword && error.confirmPassword}
                    </p>
                  </div>
                </div>

                {/* <!--Submit button--> */}
                <div className="pb-1 pt-1 text-center">
                  <button
                    onClick={handleSignup}
                    className={`mb-3 inline-block w-full rounded px-6 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_rgba(0,0,0,0.2)] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:outline-none focus:ring-0 active:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] disabled:cursor-not-allowed disabled:opacity-70 ${
                      !loading && "pb-2 pt-2.5"
                    }`}
                    type="button"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    style={{
                      background:
                        "linear-gradient(to right, rgb(190 49 199), rgb(170 46 226), rgb(91 146 245), rgb(50 197 255))",
                    }}
                  >
                    {/* loading spinner svg */}
                    {loading ? (
                      <svg
                        className="mx-auto bg-transparent"
                        width="30px"
                        height="35px"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="xMidYMid"
                      >
                        <circle
                          cx="50"
                          cy="50"
                          r="0"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                        >
                          <animate
                            attributeName="r"
                            repeatCount="indefinite"
                            dur="1s"
                            values="0;40"
                            keyTimes="0;1"
                            keySplines="0 0.2 0.8 1"
                            calcMode="spline"
                            begin="0s"
                          ></animate>
                          <animate
                            attributeName="opacity"
                            repeatCount="indefinite"
                            dur="1s"
                            values="1;0"
                            keyTimes="0;1"
                            keySplines="0.2 0 0.8 1"
                            calcMode="spline"
                            begin="0s"
                          ></animate>
                        </circle>
                        <circle
                          cx="50"
                          cy="50"
                          r="0"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                        >
                          <animate
                            attributeName="r"
                            repeatCount="indefinite"
                            dur="1s"
                            values="0;40"
                            keyTimes="0;1"
                            keySplines="0 0.2 0.8 1"
                            calcMode="spline"
                            begin="-0.5s"
                          ></animate>
                          <animate
                            attributeName="opacity"
                            repeatCount="indefinite"
                            dur="1s"
                            values="1;0"
                            keyTimes="0;1"
                            keySplines="0.2 0 0.8 1"
                            calcMode="spline"
                            begin="-0.5s"
                          ></animate>
                        </circle>
                      </svg>
                    ) : (
                      <span>Start a free trial</span>
                    )}
                  </button>
                </div>

                {/* error message */}
                <div className="text-center max-w-xs">
                  <p className="text-xs text-red-500">
                    {error.server && error.server}
                  </p>
                </div>
              </form>
              <p className="mt-2 text-center text-sm text-gray-500">
                Already a member?{" "}
                <NavLink to="/" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
                    Login
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
